import type { ReactNode } from 'react';
import type { HelpContextId } from './contexts';
import { DialogHelp } from './DialogHelp';
import styles from './DialogTitleRow.module.css';

/**
 * A dialog's title with its "?" on the right: wraps the dialog's own heading (kept with its own
 * classes) so dialogs that had a bare heading get the same help button as the New shipment box.
 */
export function DialogTitleRow({ context, title, children }: { context: HelpContextId; title: string; children: ReactNode }) {
  return (
    <div className={styles.row}>
      <div className={styles.title}>{children}</div>
      <DialogHelp context={context} title={title} />
    </div>
  );
}
